import React, { useState, useCallback, useEffect } from "react";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import AgreementStatus from "./AgreementStatus";
import FormControl from "@mui/material/FormControl";
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import { TextField } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import FileItem from "../File/FileItem";
import { useDropzone } from "react-dropzone";
import IndicatorModalForm from "./IndicatorModalForm";
import { agreementEditSchema } from "../../validations/AgreementValidation";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { agreementSchema } from "../../validations/AgreementValidation";
import FormHeader from "../Form/FormHeader";
import IndicatorList from "./IndicatorList";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import {
  updateAnalyzeAgreement,
  updateAgreement,
  getAgreement,
  getAgreementAnalyze,
} from "../../services/agreementServices";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { handleApiError } from "../../utils/errorHandler";
import { getSetting } from "../../services/settingServices";
import { STATUS_OPTIONS_PRIVATE } from "../../constants/status";
import { ListItemIcon, ListItemText } from "@mui/material";
import GetValidityChip from "./GetValidityChip";

export default function AgreementEdit() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const { id } = state;
  const [agreement, setAgreement] = useState([]);
  const [report, setReport] = useState([]);
  const [files, setFiles] = useState([]);
  const [indicators, setIndicators] = useState([]);
  const [signers, setSigners] = useState([]);
  const [newFiles, setNewFiles] = useState([]);
  const [open, setOpen] = useState(false);
  const [formEdit, setFormEdit] = useState(false);
  const [indicator, setIndicator] = useState([]);
  const [indicatorsError, setIndicatorsError] = useState(false);
  const [title, setTitle] = useState("Agregar convenio");
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page") || 1;
  const search = searchParams.get("search") || "";
  const status = searchParams.get("status") || "all";
  const [removedFiles, setRemovedFiles] = useState([]);
  const [proformaLink, setProformaLink] = useState(null);
  const [reportFiles, setReportFiles] = useState([]); // Archivos existentes del report
  const [newReportFiles, setNewReportFiles] = useState([]); // Archivos nuevos que se agregan
  const [removedReportFiles, setRemovedReportFiles] = useState([]); // Archivos eliminados




  const initEditForm = (indicator) => {
    setOpen(true),
      setTitle("Editar convenio"),
      setIndicator(indicator),
      setFormEdit(true);
  };

  const agreementData = useCallback(async () => {
    try {
      const response = await getAgreement(`/api/v1/agreements/${id}`);
      setAgreement(response.data.data);
      setFiles(response.data.data.images);
      setSigners(response.data.data.signers); 

    } catch (err) {
      if (!err?.response) {
        
      }
    }
  }, []);

  const reportData = useCallback(async () => {
    try {
      const response = await getAgreementAnalyze(id);
      setReport(response.data);
      setIndicators(response.data.indicators);
      setReportFiles(response.data.files || []);
    } catch (err) {
      if (!err?.response) {
        
      }
    }
  }, []);

  const removeOldReportFile = (fileId) => {
    setRemovedReportFiles((prev) => [...prev, fileId]);
    setReportFiles((prev) => prev.filter((f) => f.id !== fileId));
  };

  const removeNewReportFile = (fileKey) => {
    setNewReportFiles((prev) => prev.filter((f) => (f.__id || f.name) !== fileKey));
  };

  const onDropReport = useCallback((acceptedFiles) => {
    if (acceptedFiles?.length) {
      setNewReportFiles((prev) => [
        ...prev,
        ...acceptedFiles.map((file) =>
          Object.assign(file, {
            __id: `${file.name}-${Date.now()}`,
            preview: URL.createObjectURL(file),
          })
        ),
      ]);
    }
  }, []);

  const { getRootProps: getRootReportProps, getInputProps: getInputReportProps, isDragActive: isDragReportActive } = useDropzone({
    onDrop: onDropReport,
    accept: { "image/*": [], "application/pdf": [".pdf"] },
  });



  useEffect(() => {
    agreementData();
  }, []);

  useEffect(() => {
    if (agreement.status && agreement.status !== "draft") {
      reportData();
    }
  }, [agreement.status]);

  const handleGoBack = () => {
    navigate(`/agreements?page=${page}&search=${search}&status=${status}`);
  };

  const onDrop = useCallback((acceptedFiles, rejectedFiles) => {
    if (acceptedFiles?.length) {
      setNewFiles((previousFiles) => [
        ...previousFiles,
        ...acceptedFiles.map((file) =>
          Object.assign(file, {
            __id: `${file.name}-${Date.now()}`,
            preview: URL.createObjectURL(file),
          })
        ),
      ]);
    }
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { "image/*": [], "application/pdf": [".pdf"] },
  });

  const onSubmit = async (data) => {
    if (
      data.agreement_type === "Específico" &&
      (!indicators || indicators.length === 0) &&
      agreement.status !== "draft"
    ) {
      setIndicatorsError(true);
      return;
    }

    // Filtrar archivos existentes que no fueron eliminados
    const remainingFiles = files.filter(
      (file) => !removedFiles.includes(file.id)
    );

    const totalFilesAfterUpdate = remainingFiles.length + newFiles.length;
    if (totalFilesAfterUpdate === 0) {
      toast.error("Debe haber al menos un archivo adjunto.");
      return;
    }
    

    // Combinar archivos viejos restantes con los nuevos
    const allFilesToSend = [...remainingFiles, ...newFiles];


    try {
      const res = await updateAgreement(id, data, newFiles, removedFiles);
    } catch (err) {
      if (!err?.response) {
        toast.error("No responde el servidor");
      } else {
        handleApiError(err, "Error al actualizar el convenio");
      }
      return;
    }

    // análisis convenio
    if (agreement.status !== "draft") {
    
      // Filtrar archivos antiguos que no fueron eliminados
      const remainingReportFiles = reportFiles.filter(
        (file) => !removedReportFiles.includes(file.id)
      );

      // Combinar con los nuevos archivos
      const allReportFilesToSend = [...remainingReportFiles, ...newReportFiles];
      try {
        const res = await updateAnalyzeAgreement(
          report.id,
          agreement.id,
          {
            academic_unit: data.academic_unit,
            career: data.career,
            proposal: data.proposal,
            evaluated_period: data.evaluated_period,
            evaluation_unit: data.evaluation_unit,
            presentation_date: data.presentation_date,
            observation: data.observation,
            coordinators: data.coordinators
          },
          allReportFilesToSend, // enviamos TODOS los archivos
          removedReportFiles     // IDs de archivos eliminados
        );
      } catch (err) {
        if (!err?.response) {
          toast.error("No responde el servidor");
        } else {
          toast.error(err.response.data.error);
        }
        return;
      }
    }

    navigate(`/agreements?page=${page}&search=${search}&status=${status}`);
    toast.success("Se actualizó los datos del convenio");
  };

  const initialValues = {
    order_number: agreement.order_number || "",
    agreement_type: agreement.agreement_type || "",
    objective: agreement.objective || "",
    entity: agreement.entity || "",
    resolution_number: agreement.resolution_number || "",
    suscription_date: agreement.suscription_date || "",
    effective_date: agreement.effective_date || "",
    signers: signers || [{ name: "", position: "" }],
    files: agreement.images || [],
    academic_unit: report.academic_unit || "",
    career: report.career || "",
    coordinators: report.coordinators || [],
    proposal: report.proposal || "",
    evaluated_period: report.evaluated_period || "",
    evaluation_unit: report.evaluation_unit || "",
    presentation_date: report.presentation_date || "",
    observation: report.observation || "",
    new_files: [],
    proponent_email: agreement.proponent_email || "",
    notification_unit: agreement.notification_unit || "",
    notification_amount: agreement.notification_amount || "",
    status: agreement.status || "",
    reportFiles: report.reportFiles
  };

  useEffect(() => {
    async function fetchSetting() {
      try {
        const data = await getSetting();
        setProformaLink(data.proforma_link);
      } catch (error) {
        console.error("Error cargando configuración:", error);
      }
    }
    fetchSetting();
  }, [])

  return (
    <Paper elevation={0} sx={{ padding: 5 }}>
      <FormHeader title={"Editar convenio"} />
      {proformaLink && (
        <Button
          variant="outlined"
          sx={{ mt: 3, mb: 3 }}
          onClick={() => window.open(proformaLink, "_blank", "noopener,noreferrer")}
        >
          Ver ejemplo de Proforma
        </Button>
      )}
      <Paper elevation={0}>
        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={
            agreement.status === "draft"
              ? agreementSchema
              : agreementEditSchema
          }
          validateOnBlur={false}
        >
          {(props) => {
             const { errors, isValid, values, setFieldValue } = props;
      

            const removeNewFile = (fileKey) => {   
            
              // Quitarlo de Formik
              setFieldValue(
                "new_files",
                values.new_files.filter((f) => (f.__id || f.name) !== fileKey)
              );
            
              // Quitarlo del estado local
              setNewFiles((prev) =>
                prev.filter((f) => (f.__id || f.name) !== fileKey)
              );
            };
            

            const removeOldFile = (fileId) => {
              
              setRemovedFiles((prev) => [...prev, fileId]);
            
              // Quitarlo de Formik
              setFieldValue(
                "files",
                values.files.filter((f) => f.id !== fileId)
              );
            
              // Quitarlo del estado local
              setFiles((prev) => prev.filter((f) => f.id !== fileId));
            };
            
            
            


            return (
              <Form>
                <Grid container direction="row" spacing={2}>
                  <Grid item xs={6}>
                    {props.values.status === "draft" ? (
                      <Box display="flex" alignItems="center" gap={1}>
                        <Typography
                          variant="subtitle1"
                          component="span"
                          sx={{ fontWeight: "bold" }}
                        >
                          Estado:
                        </Typography>
                        <GetValidityChip status={props.values.status} />
                      </Box>
                    ) : (
                      <FormControl
                        fullWidth
                        variant="outlined"
                        error={!!props.errors.status && props.touched.status}
                      >
                        <InputLabel id="status_label">Estado *</InputLabel>
                        <Select
                          labelId="status_label"
                          name="status"
                          value={props.values.status}
                          label="Estado *"
                          size="small"
                          onChange={(e) =>
                            props.setFieldValue("status", e.target.value)
                          }
                          onBlur={props.handleBlur}
                          renderValue={(selected) => {
                            const option = STATUS_OPTIONS_PRIVATE.find(
                              (opt) => opt.value === selected
                            );
                            return option ? (
                              <Box
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <ListItemIcon sx={{ minWidth: 32 }}>
                                  {React.cloneElement(option.icon, {
                                    sx: { fontSize: 20, color: option.color },
                                  })}
                                </ListItemIcon>
                                <Typography>{option.label}</Typography>
                              </Box>
                            ) : null;
                          }}
                        >
                          {STATUS_OPTIONS_PRIVATE.filter(
                            (opt) =>
                              opt.value !== "all" && opt.value !== "draft"
                          ).map((opt) => (
                            <MenuItem key={opt.value} value={opt.value}>
                              <ListItemIcon sx={{ minWidth: 36 }}>
                                {React.cloneElement(opt.icon, {
                                  sx: { fontSize: 22, color: opt.color },
                                })}
                              </ListItemIcon>
                              <ListItemText primary={opt.label} />
                            </MenuItem>
                          ))}
                        </Select>
                        <ErrorMessage
                          name="status"
                          component="div"
                          style={{
                            color: "#d32f2f",
                            fontSize: "0.75rem",
                            marginTop: "4px",
                          }}
                        />
                      </FormControl>
                    )}
                  </Grid>

                  <Grid item xs={6}>
                    <Box display="flex" alignItems="center" gap={1}>
                      <Typography
                        variant="subtitle1"
                        component="span"
                        sx={{ fontWeight: "bold" }}
                      >
                        Creado por:
                      </Typography>
                      {agreement.user?.name}
                    </Box>
                  </Grid>

                  <Grid item xs={6}>
                    <Field
                      as={TextField}
                      name="order_number"
                      htmlFor="order_number"
                      type="text"
                      fullWidth
                      size="small"
                      label="Nº de orden en el archivo físico *"
                      variant="outlined"
                      value={props.values.order_number}
                      autoFocus
                      error={
                        !!props?.errors?.order_number &&
                        props?.touched?.order_number
                      }
                      helperText={<ErrorMessage name="order_number" />}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      label="Tipo de convenio *"
                      name="agreement_type"
                      htmlFor="agreement_type"
                      variant="outlined"
                      value={props.values.agreement_type}
                      onChange={(e) => {
                        props.setFieldValue("agreement_type", e.target.value);
                      }}
                      error={
                        !!props?.errors?.agreement_type &&
                        props?.touched?.agreement_type
                      }
                      helperText={<ErrorMessage name="agreement_type" />}
                    >
                      <MenuItem value="Marco">Marco</MenuItem>
                      <MenuItem value="Específico">Específico</MenuItem>
                      <MenuItem value="Adenda o Anexo">Adenda o Anexo</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item xs={6}>
                    <Field
                      as={TextField}
                      name="objective"
                      htmlFor="objective"
                      type="text"
                      fullWidth
                      size="small"
                      label="Objetivo *"
                      value={props.values.objective}
                      variant="outlined"
                      multiline
                      maxRows={4}
                      error={
                        !!props?.errors?.objective && props?.touched?.objective
                      }
                      helperText={<ErrorMessage name="objective" />}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Field
                      as={TextField}
                      name="entity"
                      htmlFor="entity"
                      type="text"
                      fullWidth
                      size="small"
                      label="Institución Co-celebrante *"
                      value={props.values.entity}
                      variant="outlined"
                      error={!!props?.errors?.entity && props?.touched?.entity}
                      helperText={<ErrorMessage name="entity" />}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Field
                      as={TextField}
                      name="resolution_number"
                      htmlFor="resolution_number"
                      type="text"
                      fullWidth
                      size="small"
                      label="Nº de resolución *"
                      value={props.values.resolution_number}
                      variant="outlined"
                      error={
                        !!props?.errors?.resolution_number &&
                        props?.touched?.resolution_number
                      }
                      helperText={<ErrorMessage name="resolution_number" />}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <DatePicker
                      value={dayjs(props.values.suscription_date)}
                      onChange={(value) =>
                        props.setFieldValue("suscription_date", value)
                      }
                      format="DD/MM/YYYY"
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          size: "small",
                          name: "suscription_date",
                          variant: "outlined",
                          label: "Fecha de suscripción *",
                          error:
                            !!props?.errors?.suscription_date &&
                            props?.touched?.suscription_date,
                          helperText: <ErrorMessage name="suscription_date" />,
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <DatePicker
                      value={dayjs(props.values.effective_date)}
                      format="DD/MM/YYYY"
                      onChange={(value) =>
                        props.setFieldValue("effective_date", value)
                      }
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          size: "small",
                          name: "effective_date",
                          variant: "outlined",
                          label: "Fecha de vigencia *",
                          error:
                            !!props?.errors?.effective_date &&
                            props?.touched?.effective_date,
                          helperText: <ErrorMessage name="effective_date" />,
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={6}>
                        <Field
                          as={TextField}
                          name="notification_amount"
                          type="number"
                          size="small"
                          fullWidth
                          label="Notificar antes de *"
                          placeholder="Notificar antes de *"
                          value={props.values.notification_amount}
                          variant="outlined"
                          inputProps={{ min: 1 }}
                          error={
                            !!props?.errors?.notification_amount &&
                            props?.touched?.notification_amount
                          }
                          helperText={
                            <ErrorMessage name="notification_amount" />
                          }
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl
                          fullWidth
                          size="small"
                          variant="outlined"
                          error={
                            !!props.errors.notification_unit &&
                            props.touched.notification_unit
                          }
                        >
                          <InputLabel id="notification_unit_label">
                            Unidad de tiempo *
                          </InputLabel>
                          <Select
                            labelId="notification_unit_label"
                            id="notification_unit"
                            name="notification_unit"
                            value={props.values.notification_unit}
                            label="Unidad de tiempo *"
                            size="small"
                            fullWidth
                            onChange={(e) => {
                              props.setFieldValue(
                                "notification_unit",
                                e.target.value
                              );
                              props.setFieldTouched("notification_unit", true);
                            }}
                            onBlur={props.handleBlur}
                          >
                            <MenuItem value="days">Días</MenuItem>
                            <MenuItem value="weeks">Semanas</MenuItem>
                            <MenuItem value="months">Meses</MenuItem>
                          </Select>
                          <ErrorMessage
                            name="notification_unit"
                            component="div"
                            style={{
                              color: "#d32f2f",
                              fontSize: "0.75rem",
                              marginTop: "4px",
                            }}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={6}>
                    <Field
                      as={TextField}
                      name="proponent_email"
                      type="email"
                      size="small"
                      fullWidth
                      label="Correo del proponente *"
                      placeholder="Ingrese el correo del proponente *"
                      value={props.values.proponent_email}
                      variant="outlined"
                      error={
                        !!props.errors.proponent_email &&
                        props.touched.proponent_email
                      }
                      helperText={<ErrorMessage name="proponent_email" />}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <FieldArray name="signers">
                      {(fieldArrayProps) => {
                        const { push, remove, form } = fieldArrayProps;
                        const { values } = form;

                        return (
                          <>
                            {props.values.signers.map((signer, index) => (
                              <Grid
                                container
                                item
                                spacing={2}
                                alignItems="center"
                                key={signer.id}
                              >
                                <Grid item xs={5}>
                                  <Field
                                    name={`signers[${index}].name`}
                                    as={TextField}
                                    label="Nombre del firmante *"
                                    fullWidth
                                    size="small"
                                    value={props.values.signers[index]?.name}
                                    error={
                                      !!props?.errors?.signers?.[index]?.name &&
                                      props?.touched?.signers?.[index]?.name
                                    }
                                    helperText={
                                      <ErrorMessage
                                        name={`signers[${index}].name`}
                                      />
                                    }
                                  />
                                </Grid>
                                <Grid item xs={5}>
                                  <Field
                                    name={`signers[${index}].position`}
                                    as={TextField}
                                    label="Cargo del firmante *"
                                    fullWidth
                                    size="small"
                                    error={
                                      !!props?.errors?.signers?.[index]
                                        ?.position &&
                                      props?.touched?.signers?.[index]?.position
                                    }
                                    helperText={
                                      <ErrorMessage
                                        name={`signers[${index}].position`}
                                      />
                                    }
                                  />
                                </Grid>
                                <Grid item xs={2} sx={{ textAlign: "center" }}>
                                  {index > 0 && (
                                    <Tooltip title="Eliminar firmante">
                                      <IconButton
                                        color="error"
                                        onClick={() => remove(index)}
                                        size="small"
                                      >
                                        <RemoveCircleIcon />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                </Grid>
                              </Grid>
                            ))}
                            <Grid item xs={12}>
                              <Button
                                variant="outlined"
                                startIcon={<AddCircleIcon />}
                                onClick={() => push({ name: "", position: "" })}
                              >
                                Agregar firmante
                              </Button>
                            </Grid>
                          </>
                        );
                      }}
                    </FieldArray>
                  </Grid>

                  <Grid item xs={12}>
                    <Card
                      sx={{
                        border: "3px dashed #cbd5e0 ",
                        backgroundColor: "#edf2f7",
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                        flexDirection: "column",
                      }}
                      {...getRootProps()}
                    >
                      <CardContent>
                        <input {...getInputProps()} />
                        {isDragActive ? (
                          <p>Suelte los archivos aquí ...</p>
                        ) : (
                          <p>
                            Arrastre y suelte algunos archivos aquí, o haga clic
                            para seleccionar archivos
                          </p>
                        )}

                        <Typography variant="body2">
                          Archivos soportados
                          <br />
                          PDF, JPG, PNG
                        </Typography>
                      </CardContent>
                    </Card>

                    {files && (
                      <FileItem
                        key="file-item-old"
                        files={files}
                        removeFile={removeOldFile}
                        displayDeleteButton={true}
                        editAgreement={true}
                      />
                    )}
                    {newFiles && (
                      <FileItem
                        key="file-item-new"
                        files={newFiles}
                        removeFile={removeNewFile}
                        displayDeleteButton={true}
                        editAgreement={true}
                      />
                    )}
                  </Grid>

                  {agreement.status !== "draft" && (
                    <>
                      <Grid item xs={6}>
                        <Field
                          as={TextField}
                          name="academic_unit"
                          type="text"
                          fullWidth
                          label="Unidad académica"
                          variant="outlined"
                          value={props.values.academic_unit}
                          error={
                            !!props?.errors?.academic_unit &&
                            props?.touched?.academic_unit
                          }
                          helperText={<ErrorMessage name="academic_unit" />}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Field
                          as={TextField}
                          name="career"
                          type="text"
                          fullWidth
                          label="Carrera"
                          variant="outlined"
                          value={props.values.career}
                          error={
                            !!props?.errors?.career && props?.touched?.career
                          }
                          helperText={<ErrorMessage name="career" />}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <FieldArray name="coordinators">
                          {(fieldArrayProps) => {
                            const { push, remove, form } = fieldArrayProps;
                            const { values } = form;
                            const { coordinators } = values;

                            return (
                              <>
                                {coordinators.map((_, index) => (
                                  <Grid container direction={"row"}>
                                    <Grid>
                                      <Field
                                        name={`coordinators[${index}].name`}
                                        as={TextField}
                                        label="Nombre del coordinador/designado"
                                        error={
                                          !!props?.errors?.coordinators?.[index]
                                            ?.name &&
                                          props?.touched?.coordinators?.[index]
                                            ?.name
                                        }
                                        fullWidth
                                        helperText={
                                          <ErrorMessage
                                            name={`coordinators[${index}].name`}
                                          />
                                        }
                                      />
                                    </Grid>
                                    <Grid sx={{ paddingLeft: 2 }}>
                                      {index > 0 && (
                                        <Button
                                          variant="outlined"
                                          startIcon={<RemoveCircleIcon />}
                                          onClick={() => remove(index)}
                                        />
                                      )}
                                    </Grid>
                                  </Grid>
                                ))}
                                <Grid>
                                  <Button
                                    variant="outlined"
                                    startIcon={<AddCircleIcon />}
                                    onClick={() => push("")}
                                  >
                                    Agregar coordinador
                                  </Button>
                                </Grid>
                              </>
                            );
                          }}
                        </FieldArray>
                      </Grid>
                      <Grid item xs={6}>
                        <Field
                          as={TextField}
                          name="proposal"
                          type="text"
                          fullWidth
                          label="Celebrando a propuesta de *:"
                          value={props.values.proposal}
                          variant="outlined"
                          error={
                            !!props?.errors?.proposal &&
                            props?.touched?.proposal
                          }
                          helperText={<ErrorMessage name="proposal" />}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Field
                          as={TextField}
                          name="evaluated_period"
                          type="text"
                          fullWidth
                          label="Periodo evaluado *"
                          value={props.values.evaluated_period}
                          variant="outlined"
                          error={
                            !!props?.errors?.evaluated_period &&
                            props?.touched?.evaluated_period
                          }
                          helperText={<ErrorMessage name="evaluated_period" />}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Field
                          as={TextField}
                          name="evaluation_unit"
                          type="text"
                          fullWidth
                          label="Unidad evaluadora *"
                          value={props.values.evaluation_unit}
                          variant="outlined"
                          error={
                            !!props?.errors?.evaluation_unit &&
                            props?.touched?.evaluation_unit
                          }
                          helperText={<ErrorMessage name="evaluation_unit" />}
                        />
                      </Grid>

                      {props.values.agreement_type === "Específico" && (
                        <>
                          <IndicatorList
                            id={agreement.id}
                            name="indicators"
                            indicators={indicators}
                            showButtons={true}
                            setIndicators={setIndicators}
                            onHandleEdit={initEditForm}
                            setAgreementStatus={null}
                          />
                          <Grid style={{ color: "#d32f2f" }}>
                            {indicatorsError &&
                              "Debe agregar al menos un indicador"}
                          </Grid>
                          <IndicatorModalForm
                            setIndicators={setIndicators}
                            id={id}
                            open={open}
                            setOpen={setOpen}
                            initialValues={
                              formEdit
                                ? {
                                    name: indicator.name,
                                    status: indicator.status,
                                    description: indicator.description,
                                  }
                                : { name: "", status: "", description: "" }
                            }
                            edit={formEdit}
                            indicatorId={indicator.id}
                            setFormEdit={setFormEdit}
                            setIndicatorsError={setIndicatorsError}
                          />
                        </>
                      )}
                      <Grid item xs={6}>
                        <DatePicker
                          value={dayjs(props.values.presentation_date)}
                          onChange={(value) => {
                            props.setFieldValue("presentation_date", value);
                            props.setFieldTouched("presentation_date", true);
                          }}
                          onBlur={props.handleBlur}
                          format="DD/MM/YYYY"
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              name: "presentation_date",
                              variant: "outlined",
                              label: "Fecha de presentación *",
                              error:
                                !!props?.errors?.presentation_date &&
                                props?.touched?.presentation_date,
                              helperText: (
                                <ErrorMessage name="presentation_date" />
                              ),
                            },
                          }}
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <Field
                          as={TextField}
                          name="observation"
                          type="text"
                          fullWidth
                          label="Observación *"
                          placeholder="Observación *"
                          variant="outlined"
                          error={
                            !!props?.errors?.observation &&
                            props?.touched?.observation
                          }
                          helperText={<ErrorMessage name="observation" />}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Card
                          {...getRootReportProps()}
                          sx={{
                            border: "3px dashed #cbd5e0",
                            backgroundColor: "#edf2f7",
                          }}
                        >
                          <CardContent>
                            <input {...getInputReportProps()} />
                            {isDragReportActive ? (
                              <p>Suelte los archivos aquí ...</p>
                            ) : (
                              <p>
                                Arrastre y suelte archivos del report aquí, o
                                haga clic para seleccionar
                              </p>
                            )}
                            <Typography variant="body2">
                              Archivos soportados: PDF, JPG, PNG
                            </Typography>
                          </CardContent>
                        </Card>

                        {console.log("reporte filesss ", reportFiles)}

                        {reportFiles && (
                          <FileItem
                            key="file-item-report-old"
                            files={reportFiles}
                            removeFile={removeOldReportFile}
                            displayDeleteButton={true}
                            editAgreement={true}
                          />
                        )}

                        {newReportFiles && (
                          <FileItem
                            key="file-item-report-new"
                            files={newReportFiles}
                            removeFile={removeNewReportFile}
                            displayDeleteButton={true}
                            editAgreement={true}
                          />
                        )}
                      </Grid>
                    </>
                  )}
                </Grid>

                <Grid
                  container
                  justifyContent="flex-end"
                  spacing={2}
                  sx={{ mt: 4 }}
                >
                  <Grid item>
                    <Button variant="contained" type="submit" size="large">
                      Guardar
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="outlined"
                      onClick={handleGoBack}
                      size="large"
                    >
                      Cancelar
                    </Button>
                  </Grid>
                </Grid>
              </Form>
            );
          }}
        </Formik>
      </Paper>
    </Paper>
  );
}
